import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export class MergeTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private prefix: string, private suffix: string) {}

  getTranslation(lang: string): Observable<any> {
    const baseLang = 'pt-BR';

    if (lang === baseLang) {
      return this.http.get(`${this.prefix}${baseLang}${this.suffix}`);
    }

    return forkJoin({
      base: this.http.get(`${this.prefix}${baseLang}${this.suffix}`),
      overrides: this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
        catchError(() => of({}))
      ),
    }).pipe(
      map(({ base, overrides }) => this.deepMerge(base, overrides))
    );
  }

  private deepMerge(target: any, source: any): any {
    const result = { ...target };
    for (const key of Object.keys(source)) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        result[key] = this.deepMerge(result[key] || {}, source[key]);
      } else {
        result[key] = source[key];
      }
    }
    return result;
  }
}

export function createMergeLoader(http: HttpClient) {
  return new MergeTranslateLoader(http, './assets/i18n/', '.json');
}
